<div class="lottie-loader-wrapper" @opacityInOutSlow *ngIf="visible">
  <div class="lottie-loader">
    <div class="lottie-loader__inner">
      <div class="lottie-loader__animation">
        <ng-lottie *ngIf="isBrowser" [options]="options"></ng-lottie>
      </div>
      <h3 @opacityInOut *ngIf="msg && textVisible">
        {{ msg }}
      </h3>
    </div>
  </div>
</div>
